/* eslint-disable import/no-default-export */
import actions from './actions'
import mutations from './mutations'

const state = {
  score: 0,
  consumeScoreMonth: 0,
  produceScoreMonth: 0,
  gradeInfo: {},
  ruleUrl: ''
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
